import { Box, Typography, useTheme, Button } from "@mui/material";
import { tokens } from "../../../theme";
import classes from "./user-contract.module.css";
import IconButton from "@mui/material/IconButton";

import { useRef, useState, useEffect } from "react";

// import html2canvas from 'html2canvas';
// import { jsPDF } from 'jspdf';

import JsPDF from "jspdf";
// import moment from "moment";

import LocalPrintshopTwoToneIcon from "@mui/icons-material/LocalPrintshopTwoTone";
import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined';

import { useNavigate, useLocation } from "react-router-dom";

import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import ContractPromissoryPage from "../contract-promissory-page";


const months = {
    1: "Janeiro",
    2: "Fevereiro",
    3: "Março",
    4: "Abril",
    5: "Maio",
    6: "Junho",
    7: "Julho",
    8: "Agosto",
    9: "Setembro",
    10: "Outubro",
    11: "Novembro",
    12: "Dezembro"
};

const UserContractPage = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {
        dataFromUser,
        handleClose,
        includePromissory = false,
        selectedKit = null,
        standalonePromissory = null,
    } = props;

    const [currentDate, setCurrentDate] = useState({});

    const modalContentRef = useRef();

    const [userData, setUserData] = useState({});


    const navigate = useNavigate();
    const { state, pathname } = useLocation();

    console.log('data from navigation: ', state?.data)
    console.log('pathName: ', pathname)


    useEffect(() => {
        if (pathname && pathname === "/vendedoras/contrato") {
            setUserData(state?.data || {});
        } else {
            setUserData(dataFromUser || {});
        }
    }, [pathname, state, dataFromUser]);


    const routeIncludePromissory = pathname === "/vendedoras/contrato"
        ? !!state?.includePromissory
        : !!includePromissory;

    const routeSelectedKit = pathname === "/vendedoras/contrato"
        ? state?.selectedKit || null
        : selectedKit;

    const routeStandalonePromissory =
        pathname === "/vendedoras/contrato"
            ? state?.standalonePromissory || null
            : standalonePromissory;

    const hasPromissoryData =
        Boolean(routeSelectedKit) ||
        Boolean(routeStandalonePromissory);




    useEffect(() => {

    }, []);

    useEffect(() => {
        const getCurrentDate = () => {
            const date = new Date();
            const day = date.getDate().toString().padStart(2, "0"); // Adds leading zero if needed
            const month = (date.getMonth() + 1).toString(); // Months are 0-indexed, so add 1
            const year = date.getFullYear().toString();

            return {
                day: day,
                month: month,
                year: year
            };
        };
        const currD = getCurrentDate();
        setCurrentDate(currD);
    }, []);

    const formatCPF = (cpf) => {
        // Remove any non-digit characters (if needed)
        cpf = cpf.replace(/\D/g, "");

        // Format the string as '###.###.###-##'
        const formattedCPF = cpf.replace(
            /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
            "$1.$2.$3-$4"
        );

        return formattedCPF;
    };

    const formatPostalCode = (code) => {
        // Remove any non-digit characters (if needed)
        code = code.replace(/\D/g, "");

        // Format the string as '##.###-###'
        const formattedCode = code.replace(
            /^(\d{2})(\d{3})(\d{3})$/,
            "$1.$2-$3"
        );

        return formattedCode;
    };

    const goToPage = () => {
        if (pathname === "/vendedoras/contrato") {
            let suffix = "";

            if (
                routeIncludePromissory &&
                routeSelectedKit?.kit_number
            ) {
                suffix = `_promissoria_kit_${routeSelectedKit.kit_number}`;
            } else if (
                routeIncludePromissory &&
                routeStandalonePromissory
            ) {
                suffix = "_promissoria_avulsa";
            }

            const safeSellerName = String(
                userData?.nome || "vendedora"
            )
                .trim()
                .replace(/\s+/g, "_");

            const saveFile = `contrato_${safeSellerName}${suffix}`;

            document.title = window.parent.document.title =
                saveFile;

            window.print();

            document.title = window.parent.document.title =
                "Pitaya Pay";

            return;
        }

        navigate("/vendedoras/contrato", {
            state: {
                data: userData || dataFromUser,
                includePromissory,
                selectedKit,
                standalonePromissory,
            },
        });
    };


    const goToPageBack = () => {
        navigate("/vendedoras", { state: { from: 'contrato' } });
    }

    const exportToPDF = () => {
        const pdf = new JsPDF("portrait", "pt", "a4", false);

        const contentHeight =
            document.querySelector("#printDivProgram").offsetHeight;

        // Set the maximum height of each page (adjust as needed)
        const maxHeightPerPage = 1200; // For example, assuming each page can hold up to 800px of content

        // Calculate the number of pages needed
        const totalPages = Math.ceil(contentHeight / maxHeightPerPage);
        console.log("total pages: ", totalPages);

        // const formatDate = "YYYY.MM.DD";
        // const today = new Date();
        // const dateNameFilte = '2020202'

        const saveFile = `contrato_${userData.cpf}`;

        let pWidth = pdf.internal.pageSize.width; // 595.28 is the width of a4
        let srcWidth = document.getElementById("printDivProgram").scrollWidth;
        let margin = 18; // narrow margin - 1.27 cm (36);
        let scale = (pWidth - margin * 2) / srcWidth;

        pdf
            .html(document.getElementById("printDivProgram"), {
                x: margin,
                y: margin,
                margin: [25, 0, 50, 0],
                autoPaging: "text",
                html2canvas: {
                    scale: scale,
                    allowTaint: true,
                    useCORS: true
                }
                // callback: function () {
                // 	window.open(pdf.output("bloburl"));
                // }
            })
            .then(() => {
                pdf.save(`${saveFile}.pdf`);
            });
    };
    return (
        <Box ref={modalContentRef} className={classes.mainContainerPage}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: pathname && pathname === '/vendedoras/contrato' ? "space-between" : 'flex-end',
                    position: "sticky",
                    top: "10px",
                    height: "0",
                }}
                id="printButton"
            >
                {
                    pathname && pathname === '/vendedoras/contrato' &&

                    <IconButton
                        aria-label="print"
                        onClick={goToPageBack}
                        variant="contained"
                        color="primary"
                        size="large"
                    >
                        <ArrowCircleLeftOutlinedIcon fontSize="inherit" />
                    </IconButton>
                }
                <IconButton
                    aria-label="print"
                    onClick={goToPage}
                    variant="contained"
                    color="primary"
                    size="large"
                >
                    <LocalPrintshopTwoToneIcon fontSize="inherit" />
                </IconButton>
            </Box>
            {
                userData?.id &&

                <div className={classes.printDiv} id="printDivProgram">
                    <Box
                        sx={{
                            display: "flex",
                            width: "100%",
                            // backgroundColor: 'red',
                            justifyContent: "center",
                            alignItems: "center"
                        }}
                    >
                        <h2 className={classes.titleHeader}>
                            CONTRATO DE VENDA EM CONSIGNAÇÃO
                        </h2>
                    </Box>
                    {/* <p>{userData.id}</p>
                <p>{userData.nome}</p>
                <p>{userData.email}</p> */}
                    <div
                        style={{
                            fontFamily: "Arial",
                            color: "black"
                        }}
                    >
                        <div className={classes.containerCont}>
                            <b>CONSIGNANTE: Pitaya Joias</b>, com sede em Porto Alegre/RS, na
                            Rua Dr. Armando Barbedo nº 425 Torre 1 sala 404, CEP 91.920-520, inscrita no CNPJ. sob o nº
                            30.822.328/0001-54, representada por sua Diretora Vanessa Bernardi
                            Brun Marcon, brasileira, casada, administradora de empresas,
                            carteira de Identidade nº 7088482158, CPF nº 016.963.390-06,
                            residente e domiciliada na Travessa Nova Trento, n. 49 apto 303 –
                            Tristeza – Porto Alegre/RS.
                        </div>
                        <div className={classes.containerCont}>
                            <b>CONSIGNATÁRIA: {userData.nome}</b>, brasileira, <b>autônoma</b>,
                            CPF. nº <b>{formatCPF(userData.cpf)}</b>, residente e domiciliada na{" "}
                            <b><span className={!userData?.end_logradouro && classes.missingInfo}>{userData?.end_logradouro ? userData?.end_logradouro : 'Rua não Informada'}</span> nº <span className={!userData?.end_numero && classes.missingInfo}>{userData?.end_numero ? userData?.end_numero : ' não Informado'}</span><span >{userData?.end_complemento && ` ${userData?.end_complemento}`}</span>,</b> Bairro{" "}
                            <b><span className={!userData?.end_bairro && classes.missingInfo}>{userData?.end_bairro ? userData?.end_bairro : ' não Informado'}</span>, <span className={!userData?.end_municipio && classes.missingInfo}>{userData?.end_municipio ? userData?.end_municipio : ' Cidade não Informada '}</span> - RS,
                                CEP <span className={!userData?.end_cep && classes.missingInfo}>{userData?.end_cep ? formatPostalCode(userData?.end_cep) : ' não Informado'}</span>.
                            </b>
                        </div>

                        <div className={classes.containerCont}>
                            Ambas, doravante denominadas em conjunto como
                            <b> (“Partes”) </b>e isoladamente como
                            <b> (“Parte”).</b>
                        </div>

                        <div className={classes.containerCont}>
                            <b>CONSIDERANDOS:</b>
                            <br />

                            <div className={classes.listLitlleBullet}>
                                <b>
                                    {" "}
                                    a) <span>Considerando</span>{" "}
                                </b>
                                que a <b>CONSIGNANTE</b> é sociedade atuante no comércio varejista
                                de artigos de vestuário, acessórios, bijuterias, joias e
                                semijoias; <br />
                            </div>
                            <div className={classes.listLitlleBullet}>
                                <b>
                                    {" "}
                                    b) <span>Considerando</span>{" "}
                                </b>
                                que a <b>CONSIGNATÁRIA </b>
                                pretende tomar em consignação produtos comercializados pela
                                CONSIGNANTE, para de forma autônoma revender no seu mercado de
                                atuação; <br />
                            </div>
                            <div className={classes.listLitlleBullet}>
                                <b>
                                    {" "}
                                    c) <span>Resolvem as partes</span>{" "}
                                </b>{" "}
                                por firmar a presente relação que será regida pelo Código Civil,
                                na modalidade de Contrato Estimatório, conforme dispõem os artigos
                                534 e seguintes;
                            </div>
                        </div>

                        <div className={classes.containerCont}>
                            Assim, as partes acima identificadas têm, entre si, justo e acertado
                            o presente <b>Contrato de Venda em Consignação</b>, que se regerá pelas
                            cláusulas seguintes e pelas condições descritas no presente.
                        </div>

                        <div className={classes.containerCont}
                        >
                            <b>
                                OBJETO DO CONTRATO:
                            </b>
                        </div>

                        <div className={classes.containerCont}>
                            <u>Cláusula Primeira</u>
                            : O presente contrato tem como OBJETO a consignação
                            de semijoias da <b>CONSIGNANTE</b>, para revenda pela <b>CONSIGNATÁRIA</b>.
                        </div>

                        <div className={classes.containerCont}>
                            <u>Cláusula Segunda</u>: Os produtos tomados em consignação, assim como
                            seus preços e prazo para prestação de contas <b>(Acerto)</b> pela
                            <b> CONSIGNATÁRIA</b>, serão relacionados em planilha autônoma <b>(Planilha)</b>,
                            individual para cada coleta de produtos, e que serão parte
                            integrantes do presente instrumento.
                        </div>
                        <div className={classes.containerCont}>
                            <u>Cláusula Terceira</u>: Caberá a <b>CONSIGNANTE</b>, no ato de recebimento das
                            mercadorias, realizar a conferência dos produtos entregues, assim
                            como a existência de eventuais defeitos nas peças, ficando certo e
                            ajustado que, inexistindo qualquer ressalva da <b>CONSIGNANTE</b>, em ato
                            imediato, considerar-se-á aceite tácito do seu conteúdo e estado de
                            conservação.
                        </div>

                        <div className={classes.containerCont}>
                            <b>DO ACERTO E REPASSE DOS VALORES:</b>
                        </div>

                        <div className={classes.containerCont}>
                            <u>Cláusula Quarta</u>: O pagamento dos produtos consignados e vendidos
                            será feito através de depósito em conta corrente da <b>CONSIGNANTE
                                (Banco Cooperativo Sicredi S.A. (748), agência 0116, conta corrente
                                90277-5)</b>, na data previamente acordada, esta, descrita na relação de
                            mercadorias consignadas na Planilha. Também poderá ser feito o
                            pagamento através da plataforma de pagamentos Pitaya Pay
                            <i> (https://pitaya-pay.netlify.app/)</i> <u><b>conforme os meios disponíveis no
                                sítio eletrônico.</b></u>
                        </div>
                        <div className={classes.containerCont}>
                            <b>§ 1º</b> A inadimplência no pagamento na data do acerto gera
                            imediatamente a faculdade ao <b>CONSIGNANTE</b> de cobrá-las por todos os
                            meios jurídicos admitidos, bem como de rescindir o presente
                            contrato.
                        </div>

                        <div className={classes.containerCont}>
                            <b>§ 2º</b> Em caso de atraso na devolução dos bens consignados, serão
                            cobrados multa de 10% sobre o valor total dos produtos consignados,
                            acrescidos de juros de mora de 1% (um por cento) ao mês e correção
                            monetária, pelo IGP-M (FGV), ou outro, em caso de extinção deste,
                            que melhor o reflita.
                        </div>

                        <div className={classes.containerCont}>
                            <b>§ 3º</b> Em caso de atraso no pagamento das vendas, serão cobrados multa
                            de 10% sobre o valor total dos das vendas, acrescidos de juros de
                            mora de 1% (um por cento) ao mês e correção monetária, pelo IGP-M
                            (FGV), ou outro, em caso de extinção deste, que melhor o reflita.
                        </div>
                        <div className={classes.containerCont}>
                            <b>§ 4º</b> A entrega dos produtos e conferência deverão ser feitas na sede
                            da <b>CONSIGNANTE</b>, considerando o valor total vendido no período
                            acordado. Sendo imprescindível o controle impresso da relação de
                            mercadorias consignadas, controlado pela <b>CONSIGNATÁRIA</b>.
                        </div>

                        <div className={classes.containerCont}>
                            <b>DAS COMISSÕES:</b>
                        </div>

                        <div className={classes.containerCont}>
                            <u>Cláusula Quinta:</u> Fica acertado no presente instrumento que a
                            <b> CONSIGNATÁRIA</b> receberá
                        </div>
                        <div className={classes.containerCont}>
                            <div className={classes.listBullet}>
                                <div className={classes.listLitlleBulletNoMargin}>
                                    a)
                                    <span >
                                        25% <b>(vinte e cinco por cento)</b> de comissão sobre a venda
                                        inferior a R$ 500,00;
                                    </span>
                                </div>

                                <div className={classes.listLitlleBulletNoMargin}>
                                    b)
                                    <span>
                                        30% <b>(trinta por cento)</b> de comissão sobre a venda inferior a
                                        R$ 1.000,00 e;
                                    </span>
                                </div>
                                <div className={classes.listLitlleBulletNoMargin}>
                                    c)
                                    <span>

                                        35% <b>(trinta e cinco por cento)</b> sobre a venda inferior a R$
                                        1.500,00 e;
                                    </span>
                                </div>
                                <div className={classes.listLitlleBulletNoMargin}>
                                    d)
                                    <span>

                                        40% <b>(quarenta por cento)</b> sobre a venda superior ou igual a R$
                                        1.500,00.
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className={classes.containerCont}>
                            <b>§ único</b>: Os valores das comissões serão abatidos dos valores pagos à
                            <b>CONSIGNANTE</b>, em razão das vendas realizadas pela <b>CONSIGNATÁRIA</b>, após
                            a concordância da <b>CONSIGNANTE</b> em relação aos valores.
                        </div>

                        <div className={classes.containerCont}
                        ><b>DOS PRODUTOS:</b>
                        </div>
                        <div className={classes.containerCont}>
                            <u>Cláusula Sexta:</u> O preço do produto a ser comercializado será
                            estabelecido pela <b>CONSIGNANTE</b>.
                        </div>
                        <div className={classes.containerCont}>
                            <u>Cláusula Sétima:</u> A <b>CONSIGNATÁRIA</b> responderá pelos prejuízos
                            acontecidos, se a mesma não comunicar, ao receber as mercadorias, as
                            avarias, a diminuição ou mudança de seu estado;
                        </div>
                        <div className={classes.containerCont}>
                            <u>Cláusula Oitava:</u> A <b>CONSIGNTÁRIA</b> se compromete a manter o local o
                            qual ficarão as mercadorias em perfeito estado, evitando-se desta
                            forma a deterioração dos produtos.
                        </div>

                        <div className={classes.containerCont}>
                            <b>DAS OBRIGAÇÕES:</b>
                        </div>

                        <div className={classes.containerCont}>
                            <b>a) São obrigações da CONSIGNANTE:</b>
                        </div>
                        <div className={classes.containerCont}>
                            <u>Cláusula Nona:</u> Responsabilizar-se por qualquer vício oculto ou
                            aparente nos bens, anteriores a sua entrega a <b>CONSIGNATÁRIA</b>.
                        </div>
                        <div className={classes.containerCont}>
                            <u>Cláusula Décima</u>: Realizar as diligências e prestar toda assistência
                            a <b>CONSIGNATÁRIA</b> para que receba os bens, objeto deste contrato, no
                            tempo e modo acordados.
                        </div>
                        <div className={classes.containerCont}>
                            <u>Cláusula Décima Primeira</u>: Repor os bens de acordo com a frequência
                            prevista no contrato;
                        </div>
                        <div className={classes.containerCont}>
                            <b>b) São obrigações da CONSIGNATÁRIA:</b>
                        </div>

                        <div className={classes.containerCont}>
                            <u>Cláusula Décima Segunda</u>: Não distorcer as informações sobre os
                            produtos oferecidos aos seus clientes, sob pena de
                            responsabilizar-se por eventual orientação ou promessa que não tiver
                            sido previamente acertado com a <b>CONSIGNANTE</b>, ou informado por esta.
                        </div>
                        <div className={classes.containerCont}>
                            <u>Cláusula Décima Terceira</u>: Responsabilizar-se pela perda ou
                            deterioração dos bens, mesmo em caso fortuito ou força maior,
                            pagando o preço devido.
                        </div>
                        <div className={classes.containerCont}>
                            <u>Cláusula Décima Quarta</u>: Autorizar a <b>CONSIGNANTE</b>, sempre que esta
                            desejar, mediante aviso prévio, verificar os bens dados em
                            consignação no estabelecimento do consignatário, podendo executar a
                            verificação do controle de saída das mercadorias consignadas, de
                            maneira a conferir os créditos obtidos pela <b>CONSIGNATÁRIA</b>.
                        </div>
                        <div className={classes.containerCont}>
                            <u>Cláusula Décima Quinta</u>: Entregar no tempo e modo ajustados a relação
                            dos bens consignados neste contrato e vendidos aos seus clientes,
                            sem prejuízo da conferência por parte da <b>CONSIGNANTE</b>.
                        </div>

                        <div className={classes.containerCont}><b>DO CONTRATO:</b></div>
                        <div className={classes.containerCont}>
                            <u>Cláusula Décima Sexta</u>: O presente contrato não terá natureza
                            empregatícia, tampouco de representação comercial, sendo a <b>CONSIGNATÁRIA</b> autônoma, não havendo vínculo laboral entre as partes,
                            não sendo exigido da <b>CONSIGNATÁRIA</b> o cumprimento de jornada de
                            trabalho.
                        </div>
                        <div className={classes.containerCont}>
                            <u>Cláusula Décima Sétima</u>: A presente relação é regida pelo Código
                            Civil, na modalidade de Contrato Estimatório, conforme dispõem os
                            artigos 534 e seguintes, abaixo relacionados:
                        </div>
                        <div className={classes.containerCont}>
                            <div className={classes.citArt}>
                                Art. 534. Pelo contrato estimatório, o consignante entrega bens
                                móveis ao consignatário, que fica autorizado a vendê-los, pagando
                                àquele o preço ajustado, salvo se preferir, no prazo estabelecido,
                                restituir-lhe a coisa consignada. <br />
                                Art. 535. O consignatário não se exonera da obrigação de pagar o
                                preço, se a restituição da coisa, em sua integridade, se tornar
                                impossível, ainda que por fato a ele não imputável. <br />
                                Art. 536. A coisa consignada não pode ser objeto de penhora ou
                                seqüestro pelos credores do consignatário, enquanto não pago
                                integralmente o preço. <br />
                                Art. 537. O consignante não pode dispor da coisa antes de lhe ser
                                restituída ou de lhe ser comunicada a restituição.
                            </div>
                        </div>

                        <div className={classes.containerCont}>
                            <b>DAS GARANTIAS DO CONTRATO:</b>
                        </div>
                        <div className={classes.containerCont}>
                            <u>Cláusula Décima Oitava</u>: Como garantia da consignação, é assinado uma
                            nota promissória, que em caso de inadimplência no pagamento acordado
                            entre as partes, poderá ser executado após seu vencimento.
                        </div>

                        <div className={classes.containerCont}><b>DO PRAZO:</b></div>
                        <div className={classes.containerCont}>
                            <u>Cláusula Décima Nona</u>: O prazo do presente contrato é indeterminado,
                            podendo ser rescindido a qualquer tempo pelas duas partes mediante
                            comunicação prévia de 10 dias.
                        </div>
                        <div className={classes.containerCont}>
                            <u>Cláusula Vigésima</u>: Ocorrendo a rescisão, a <b>CONSIGNATÁRIA</b> deverá
                            devolver todos os produtos consigo consignados, bem com repassar
                            todos os valores de vendas realizadas até então, em até 48h
                            (quarenta e oito horas) do término contratual. As mercadorias
                            continuarão sob sua responsabilidade até a ocasião da devolução.
                        </div>
                        <div className={classes.containerCont}>
                            <b>§ único</b>: Não realizados os adimplementos no prazo acima, além do
                            pagamento das multas previstas na cláusula quarta, poderá a <b>CONSIGNANTE</b> executar, de imediato, a garantia dada pela <b>CONSIGNATÁRIA</b>.
                        </div>

                        <div className={classes.containerCont}><b>DA EXTINÇÃO DO CONTRATO:</b></div>
                        <div className={classes.containerCont}>
                            <u>Cláusula Vigésima Primeira</u>: Havendo inadimplemento de quaisquer
                            cláusulas deste contrato, gerará à parte contrária a faculdade de
                            rescindi-lo.
                        </div>

                        <div className={classes.containerCont}><b>DISPOSIÇÕES FINAIS:</b></div>
                        <div className={classes.containerCont}>
                            <u>Cláusula Vigésima Segunda</u>: O inadimplemento concernente ao contrato
                            seja pela entrega dos produtos, seja pelo não pagamento, gerará a
                            faculdade para a parte cobrar perdas e danos àquela que der causa ao
                            referido inadimplemento.
                        </div>
                        <div className={classes.containerCont}>
                            <u>Cláusula Vigésima Terceira</u>: O presente contrato é válido entre as
                            partes e seus sucessores, que ficam responsáveis pelo fiel
                            comprimento do mesmo total ou parcialmente.
                        </div>
                        <div className={classes.containerCont}>
                            <u>Cláusula Vigésima Quarta</u>: O descumprimento de quaisquer cláusulas
                            deste contrato ou ocorrendo inadimplemento no pagamento dos
                            numerários devidos, total ou parcialmente, não configurará
                            modificação deste contrato ou mesmo adição às suas cláusulas.
                        </div>
                        <div className={classes.containerCont}>
                            <u>Cláusula Vigésima Quinta</u>: Para cada acerto (venda menos comissão),
                            será emitida Nota Fiscal Eletrônica com o valor do mesmo contra o
                            CPF da <b>CONSIGNATÁRIA</b>.
                        </div>
                        <div className={classes.containerCont}>
                            <b>DA UTILIZAÇÃO DA PLATAFORMA ELETRÔNICA DE PAGAMENTOS:</b>
                        </div>
                        <div className={classes.containerCont}>
                            <u>Cláusula Vigésima Sexta</u>: Em razão da <u><b>utilização das ferramentas
                                tecnológicas</b></u> disponibilizadas pela <b>Consignante</b>, por meio do sítio
                            eletrônico <i>https://pitaya-pay.netlify.app/</i>, a <b>Consignatária</b> fará a
                            coleta e uso (tratamento) de <b>Dados Pessoais</b> de terceiros, <b>Clientes</b>,
                            pelos quais se responsabiliza integralmente, na forma da legislação
                            pátria vigente, em especial, mas não somente, LGPD - Lei Geral
                            Proteção de Dados Pessoais (Lei nº 13.709/2018), Código Civil (Lei
                            Nº 10.406, de 10 de janeiro de 2002), Código Penal (Decreto-Lei nº
                            2.848, de 7 de dezembro de 1940), assim como pelas disposições deste
                            Temo.
                        </div>
                        <div className={classes.containerCont}>
                            <u>Cláusula Vigésima Sétima</u>: O tratamento dos dados aqui referidos se
                            dará com o escopo único e exclusivo de adimplemento, pelos <b>Clientes</b>,
                            à <b>Pitaya</b>, dos valores atinentes aos <b>Produtos</b> adquiridos, ou seja,
                            para cadastro e pagamento, do <b>Cliente</b>, na plataforma da <b>Pitaya</b>;
                        </div>
                        <div className={classes.containerCont}>
                            <u>Cláusula Vigésima Oitava</u>: As credenciais de acesso (login e senha)
                            fornecidas à <b>Consignatária</b> são de uso pessoal desta, intrasferível,
                            e de conhecimento exclusivo, sendo de <b>sua inteira responsabilidade</b> todo e qualquer prejuízo causado pelo fornecimento da senha pessoal
                            à terceiros, independente do motivo, ou mesmo sua utilização por
                            terceiros, ainda que não fornecidas propositalmente a estes;
                        </div>

                        <div className={classes.containerCont}>
                            <u>Cláusula Vigésima Nona</u>: Para os fins de utilização das ferramentas
                            tecnológicas fornecidas, serão consideradas confidenciais todas as
                            informações transmitidas por meios escritos, eletrônicos, verbais ou
                            quaisquer outros e de qualquer natureza;
                        </div>
                        <div className={classes.containerCont}>
                            <u>Cláusula Trigésima</u>: É proibida a cópia de qualquer informação de
                            <b>Clientes</b> para dispositivos estranhos à estrutura do Sistema
                            disponibilizado pela <b>Pitaya</b>, bem como a divulgação, compartilhamento
                            e uso, exceto se a referida ação seja estritamente necessária para a
                            prestação dos serviços contratados, devendo ser realizada com a
                            maior segurança possível e com expressa e prévia autorização do
                            representante legal da  <b>Pitaya</b>;
                        </div>
                        <div className={classes.containerCont}>
                            <u>Cláusula Trigésima Primeira</u>: Os prejuízos, de qualquer natureza,
                            causados pela <b>Consignatária</b> à <b>Pitaya</b>, ao sistema ou aos <b>Clientes</b>, em
                            razão da quebra de confidencialidade, integridade, ou utilização
                            indevida das informações e dados acessados, são de inteira <u><b>responsabilidade da Consignatária</b></u>, que se compromete com o imediato
                            reembolso/pagamento dos prejuízos causados, que poderão, ainda, ser
                            reclamados judicialmente, caso em que arcará, ainda, com custas e
                            honorários advocatícios.
                        </div>

                        <div className={classes.containerCont}>
                            <u>Cláusula Trigésima Segunda</u>: ​Para fins deste instrumento, os termos
                            “Operador”, “Controlador”, “Dados Pessoais”, “Dados Pessoais
                            Sensíveis”, “Tratamento”, “Titular”, dentre as outras elencadas no
                            artigo 5 da Lei Geral de Proteção de Dados (“LGPD”), terão o mesmo
                            significado definido na Lei.
                        </div>
                        <div className={classes.containerCont}>
                            <u>Cláusula Trigésima Terceira</u>: A <b>Consignatária</b> se compromete a: (i)
                            coletar, processar, compartilhar ou realizar quaisquer atividades de
                            tratamento aos dados pessoais relacionados ao presente Contrato em
                            acordo com as leis, regulamentos e melhores práticas acerca da
                            segurança, da confidencialidade e da proteção dos Dados Pessoais, em
                            especial as disposições da LGPD - Lei Geral de Proteção de Dados
                            Pessoais (Lei nº 13.709/2018) para a proteção desses dados pessoais
                            e a preservação da privacidade dos respectivos titulares, (ii)
                            restringir o tratamento de dados pessoais sob seu controle às
                            situações em que haja finalidade lícita e embasamento legal
                            adequado, e enquanto essas finalidades justificarem o seu
                            tratamento; (iii) cumprir políticas e normas internas aplicáveis
                            quanto ao tratamento de dados pessoais bem como as leis e
                            regulamentos sobre a matéria; (iv) manter encarregado pelo
                            tratamento de dados pessoais e canais de comunicação exclusivos para
                            contato dos titulares de dados pessoais e autoridades com relação ao
                            exercício de direitos e exigência de deveres relacionados à
                            privacidade e proteção de dados; e (v) manter-se adequadas à LGPD
                            conforme as melhores práticas de privacidade, segurança,
                            confidencialidade e proteção dos Dados Pessoais aplicáveis ao setor.
                        </div>
                        <div className={classes.containerCont}><b>DO FORO</b>:</div>
                        <div className={classes.containerCont}>
                            <u>Cláusula Trigésima Quarta</u>: Para dirimir quaisquer controvérsias
                            oriundas do CONTRATO, as partes elegem o foro da comarca de Porto
                            Alegre;
                        </div>
                        <div className={classes.containerCont}>
                            Por estarem, assim justos e contratados, firmam o presente
                            instrumento, em duas vias de igual teor, juntamente com 2 (duas)
                            testemunhas.
                        </div>

                        <div className={classes.containerCont}>
                            <div className={classes.containerDateSign}>
                                <div>
                                    Porto Alegre/RS, {currentDate && currentDate?.day} de{" "}
                                    {currentDate && months[currentDate?.month]} de{" "}
                                    {currentDate && currentDate?.year}.
                                </div>
                            </div>
                        </div>

                        <div className={classes.containerCont}>
                            <div className={classes.containerAss}>
                                <div className={classes.userSign}>
                                    <span>Vanessa B. Brun Marcon</span>
                                    <span>016.963.390-06</span>
                                </div>
                                <div className={classes.userSign}>
                                    <span>{userData.nome}</span>
                                    <span>{formatCPF(userData.cpf)}</span>
                                </div>
                            </div>
                        </div>
                        <div className={classes.containerCont}>
                            <div className={classes.containerAss}>
                                <div className={classes.userSign}>
                                    <span>TESTEMUNHA 1</span>
                                    <span style={{ textAlign: "left" }}>
                                        Nome: Bernardo Marcon{" "}
                                    </span>
                                    <span style={{ textAlign: "left" }}>
                                        RG/CPF: 015.297.400-88{" "}
                                    </span>
                                </div>
                                <div className={classes.userSign}>
                                    <span>TESTEMUNHA 2</span>
                                    <span style={{ textAlign: "left" }}>Nome: </span>
                                    <span style={{ textAlign: "left" }}>RG/CPF: </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {routeIncludePromissory && hasPromissoryData && (
                <ContractPromissoryPage
                    sellerData={userData}
                    selectedKit={routeSelectedKit}
                    standalonePromissory={
                        routeStandalonePromissory
                    }
                />
            )}
        </Box>
    );
};

export default UserContractPage;
